import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import MasterData from '../../data/MasterData'
import TrainLaneData from '../../data/TrainLaneData'

class TrainInfoModal extends React.Component {

  static propTypes = {
    lines: PropTypes.array.isRequired,
    trains: PropTypes.array.isRequired,
    showingTrain: PropTypes.object,
    themeName: PropTypes.string.isRequired,

    fetchLines: PropTypes.func.isRequired,
    fetchTrains: PropTypes.func.isRequired,
    closeTrainModal: PropTypes.func.isRequired,
  }


  static contextTypes = {
    intl: PropTypes.object
  }


  static TRAIN_KIND_CLASS = {
    0: 'is_limitedExpress',
    1: 'is_express',
    2: 'is_rapid',
    3: 'is_rapid',
    4: 'is_local',
  }

  async componentDidMount() {
    const { trainNumber } = this.props.match.params
    const { fetchLines, fetchTrains, showingTrain } = this.props

    // いきなりこのURLが開かれても表示できるようにする
    if (this.props.lines.length === 0) {
      await fetchLines()
    }
    if (showingTrain === null) {
      await fetchTrains()
      const train = this.props.trains.find(t => t.train_number === trainNumber)
    }
  }

  componentWillUnmount() {
    this.props.closeTrainModal()
  }
  
  handleCloseClick = (e) => {
    this.props.history.goBack()
  }

  // ヘッダー
  renderHeader() {
    const { lineName, trainNumber } = this.props.match.params

    return (
      <div className="c-Modal-header">
        <p className="c-Modal-headerTitle">列車情報</p>
        <Link to={`/lines/${lineName}/trains#train${trainNumber}`}>
          <div className="c-Modal-headerClose"></div>
        </Link>
      </div>
    )
  }

  renderDelay() {
    const { delay } = this.props.showingTrain
    if (100 <= delay) {
      return (
        <p className="c-Modal-infoStatus is_delay">
        </p>
      )
    } else if (0 < delay) {
      return (
        <p className="c-Modal-infoStatus">
        </p>
      )
    } else {
      // 遅延なし
      return (
        <p className="c-Modal-infoStatus">
        </p>
      )
    }
  }

  renderTrainInfo(train){
    const { lineName } = this.props.match.params
    var kind = ""
    if (lineName === "nankai") {
      kind = MasterData.nankaiTrainKindById(train.train_kind_id)
    } else {
      kind = MasterData.koyaTrainKindById(train.train_kind_id)
    }
    
    if(kind.train_type === '回送' || kind.train_type === '' ) return null

    var destination = ""
    if (lineName === "nankai") {
      destination = MasterData.nankaiDestinationById(train.destination_station_id)
    } else {
      destination = MasterData.koyaDestinationById(train)
    }

    return (
      <li key={train.train_number} className="c-Modal-trainInfoRow">
        <Link to={`/lines/${lineName}/trains/${train.train_number}`} className="c-Modal-trainInfoLink">
          <div className="c-Modal-trainInfoBodyCell -type-kind">
            <div className={`c-Modal-trainInfoKindIcon ${kind.kind}`}>
              <p>{kind.train_type}</p>
            </div>
          </div>
          <div className="c-Modal-trainInfoBodyCell -type-dest">{destination.destination_name}</div>
          <div className={`c-Modal-trainInfoBodyCell -type-delay ${train.delay === 0 ? "" : "is_late"}`}>{train.delay === 0 ? "-" : train.delay + "分"}</div>
          <div className="c-Modal-trainInfoBodyCell -type-arrow">
            <span className="is_next"></span>
          </div>
        </Link>
      </li>
    )
  }

  // 種別、両数、行き先、現在値などの表示
  renderTrainBody(trains) {

    return (
      <div className="c-Modal-body">
        <div className="c-Modal-trainInfoTable">
          <div className="c-Modal-trainInfoHeader">
            <div className="c-Modal-trainInfoHeaderCell -type-kind">種別</div>
            <div className="c-Modal-trainInfoHeaderCell -type-dest">行き先</div>
            <div className="c-Modal-trainInfoHeaderCell -type-delay">遅延</div>
            <div className="c-Modal-trainInfoHeaderCell -type-arrow"></div>
          </div>
          <ul className="c-Modal-trainInfoBody">
            {trains.map(train => this.renderTrainInfo(train))}
          </ul>
        </div>
      </div>
    )
  }

  // ヘッダー
  renderFooter() {

    return (
      <div className="c-Modal-footer">
        <p className="c-Modal-trainInfoNote">実際の運行状況と異なる場合があります。</p>
      </div>
    )
  }
  
  render() {
    const { lineName, trainNumber } = this.props.match.params
    const { trains } = this.props

    const paramTrain = trains.find(train => train.train_number === trainNumber)
    let displayTrains = trains.filter(train => 
      train.station_id == paramTrain.station_id &&
      train.next_station_id == paramTrain.next_station_id &&
      train.direction == paramTrain.direction &&
      MasterData.trainKindByLineIdAndTrainNumber(MasterData.lineIdByLineName(lineName), train.train_number).kind
    )
    if ((paramTrain.station_id >= 1 && paramTrain.station_id <= 47) || (paramTrain.station_id >= 95 && paramTrain.station_id <= 136)) {
      displayTrains = displayTrains.filter(train =>
        TrainLaneData.getByStationIdAndTrainNumber(train.station_id, train.train_number.substr(0, 2).toString()) ===
        TrainLaneData.getByStationIdAndTrainNumber(paramTrain.station_id, paramTrain.train_number.substr(0, 2).toString())
      )  
    }

    if (displayTrains.length === 0) return null

    return (
      <div className={`c-Modal is_${lineName}`}>
        <div className="c-Modal-dialog">
          {this.renderHeader()}
          {this.renderTrainBody(displayTrains)}
          {this.renderFooter()}
        </div>
      </div>
    )
  }
}

export default TrainInfoModal
